const DEFAULT_IDLE_MS = 60 * 60 * 1000;

let idleManager;

export const startIdleLogout = ({ idleMs = DEFAULT_IDLE_MS, onIdle } = {}) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null;
  if (idleManager) return idleManager;

  let lastActivity = Date.now();
  let timeoutId;
  let idleTriggered = false;

  const triggerIdle = () => {
    if (idleTriggered) return;
    idleTriggered = true;
    if (typeof onIdle === 'function') {
      onIdle();
    }
  };

  const schedule = () => {
    if (idleTriggered) return;
    if (timeoutId) window.clearTimeout(timeoutId);
    const elapsed = Date.now() - lastActivity;
    const remaining = idleMs - elapsed;
    if (remaining <= 0) {
      triggerIdle();
      return;
    }
    timeoutId = window.setTimeout(() => {
      const nowElapsed = Date.now() - lastActivity;
      if (nowElapsed >= idleMs) {
        triggerIdle();
      } else {
        schedule();
      }
    }, remaining);
  };

  const markActivity = () => {
    if (idleTriggered) return;
    lastActivity = Date.now();
    schedule();
  };

  const handleVisibility = () => {
    if (document.visibilityState !== 'visible') return;
    const elapsed = Date.now() - lastActivity;
    if (elapsed >= idleMs) {
      triggerIdle();
      return;
    }
    schedule();
  };

  const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'touchmove', 'click'];
  events.forEach((eventName) => {
    window.addEventListener(eventName, markActivity, { passive: true });
  });
  document.addEventListener('visibilitychange', handleVisibility);

  schedule();

  idleManager = {
    notifyActivity: markActivity,
    stop() {
      if (timeoutId) window.clearTimeout(timeoutId);
      events.forEach((eventName) => {
        window.removeEventListener(eventName, markActivity);
      });
      document.removeEventListener('visibilitychange', handleVisibility);
      idleManager = null;
    }
  };

  return idleManager;
};
